
import * as easy from "@/components/easy"; 
import CaptchaDialog from "./CaptchaDialog.vue"
import ModifyPasswordDialog from "./ModifyPasswordDialog.vue"
import SmsAuthDialog from "./SmsAuthDialog.vue"

const iframe = window.parent != window.self;
// 显示验证码dialog
export function showCaptchaDialog() {
	return easy.showDialog(CaptchaDialog, {}, {
		title: "图形校验", 
		customStyle: { width: iframe ? '90%' : '400px', height: '240px' }
	})
}

// 修改密码
export function showModifyPasswordDialog(action: (newPassword: string) => Promise<void>) {
	
    return easy.showDialog(ModifyPasswordDialog, { action }, {
		title: "修改密码", 
		customStyle: { width: iframe ? '90%' : '600px', height: '400px' }
	})
}

// 短信验证
export function showSmsAuthDialog(
	params: {
		phoneNumber: string,
		platformName: string,
		platformUrlName: string,
		platformUrl: string,
		inputMaxlength?: number;

		sendSmsApi: () => Promise<void>;
		verifyAuthCodeApi: (code: string) => Promise<void>;
}) {
	return easy.showDialog(SmsAuthDialog, params, {
		title: '安全验证', 
		showCancelButton: false,
		customStyle: { width: iframe ? '90%' : '360px', height: '280px' }
	})
}
